import { Record } from 'immutable'

// Record
export const CouponRecord = Record(
  {
    id: '',
    name: '',
  },
  'Coupon'
)
